import { CHOICES } from "../../utils/constants";

const ChoiceButton = ({ choice, selected, disabled, onClick }) => {
  const { emoji, label } = CHOICES[choice];

  return (
    <button
      className={`choice-btn ${selected ? "selected" : ""}`}
      onClick={() => onClick(choice)}
      disabled={disabled}
    >
      <span className="choice-emoji">{emoji}</span>
      <span className="choice-label">{label}</span>
    </button>
  );
};

export default ChoiceButton;